import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png";

const StandardsInformationService = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Standards Information Centre</h1>
          <p className="subtitle">
            Access to standards and standards-related information for industry, government, and the public. 
          </p>
        </div>
      </section>

      {/* === Content Section === */}
      <section className="content-section">
        <p className="subtitle left-text">
        The Standards Information Centre of the MBS provides information on standards and standards related matters to stakeholders.  It is also the custodian of Malawi standards, International Standards, regional standards and other foreign National Standards.  A library subscription scheme (<a href="/MBSSICmembershischeme" >
          MBS-SIC Membership Scheme</a>) is available where industries, the general public and other interested parties can subscribe to in order to have access to the various standards and standards related information at both the local and international level.
        </p>
        <p className="subtitle left-text">
        The Standards Information Centre is open to all stakeholders during normal working hours.
        </p>
        <p className="subtitle left-text">
        See the <a href="/CatalogueOfMalawiStandards">
        Catalogue of Malawi Standards </a> for list of available published Malawi Standards.
        </p>
      </section>

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 40vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

       .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title {
          font-size: 2.5rem;
          font-weight: bold;
        }

        .content-section {
          padding: 50px 80px;
          text-align: left; /* Align content to left margin */
        }

        .left-text {
          margin: 12px 0;
          font-size: 1rem;
          line-height: 1.7;
          text-align: left;
        }

        a {
          color: #ff6600;
          font-weight: ;
          text-decoration: none;
        }

        a:hover {
          text-decoration: underline;
        }

        @media screen and (max-width: 768px) {
          .about-header { height: 35vh; }
          .page-title { font-size: 2rem; }
          .content-section { padding: 25px 20px; }
        }
      `}</style>

    </div>
  );
};

export default StandardsInformationService;
